import {Inject, Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {APP_CONFIG, AppConfig} from '@src/app.config';
import {RequestService} from '@src/app/shared/services/http/request/request.service';
import {AppointmentDetail} from "@app/areas/appointments/models/appointment.interface";

@Injectable({
  providedIn: 'root'
})
export class AppointmentApiService {
  constructor(
    private requestService: RequestService,
    @Inject(APP_CONFIG) private appConfig: AppConfig,
  ) {
  }

  get(id: string): Observable<AppointmentDetail> {
    const url = `${this.appConfig.angularEndpoint}/appointments/detail/${id}`;
    return this.requestService.get(url).pipe(map(r => r.body))
  }

  /**
   * Updates the participant entity for the logged in user
   * @param firstName
   * @param lastName
   */
  updateParticipant(firstName: string, lastName: string): Observable<any> {
    const url = `${this.appConfig.angularEndpoint}/appointments/participant`;
    return this.requestService.put(url, {firstName, lastName}).pipe(map(r => r.body))
  }

  getParticipant(): Observable<any> {
    const url = `${this.appConfig.angularEndpoint}/appointments/participant`;
    return this.requestService.get(url).pipe(map(r => r.body))
  }

  list(startTime: string, endTime: string): Observable<any[]> {
    const url = `${this.appConfig.angularEndpoint}/appointments?startTime=${startTime}&endTime=${endTime}`;
    return this.requestService.get(url).pipe(map(r => r.body))
  }

  joinRoom(appointmentId: string): Observable<{ token: string, roomName: string }> {
    const url = `${this.appConfig.angularEndpoint}/appointments/joinMeeting/${appointmentId}`;
    return this.requestService.post(url).pipe(map(r => r.body))
  }

  inviteViaPhone(appointmentId: string, phoneNumber: string): Observable<any> {
    const url = `${this.appConfig.angularEndpoint}/appointments/inviteFromPhone/${appointmentId}`;
    return this.requestService.post(url, {phoneNumber}).pipe(map(r => r.body))
  }
}
